import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'src/app/local-storage.service';
import { ServiceAppModels } from 'src/app/models/serviceapp-models';
import { SwissSettingsService } from 'src/app/services/swiss-settings.service';
import { ZeitMutationComponent } from '../../zeiten/zeit-mutation/zeit-mutation.component';

@Component({
  selector: 'app-artikelstamm',
  templateUrl: './artikelstamm.component.html',
  styleUrls: ['./artikelstamm.component.scss']
})
export class ArtikelstammComponent implements OnInit {
  isLoadingResults = true;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  selectedProductNo: string = "";
  productIsChoosed: boolean = false;
  private dbStorageSA: string = "ServiceAppDB";
  private dbProdukte: ServiceAppModels.Produkt[] = [];

  dataSource: MatTableDataSource<ServiceAppModels.Produkt>;

  displayedColumns: string[] = ['productNo', 'description', 'pricePerQuantity', 'searchKey'];

  constructor(
    private localStorageService: LocalStorageService,
    public dialogRef: MatDialogRef<ZeitMutationComponent>,
    private swissSettings: SwissSettingsService,) {
    this.dataSource = new MatTableDataSource<ServiceAppModels.Produkt>();
  }

  ngOnInit(): void {
    this.loadArticlesFromIndexedDB().then(
      res => {
        if (res === true) {
          if (this.swissSettings.getWebConfig().debugMode)
            console.log("Artikel geladen...");
        }
      }
    );
    this.changePosition();
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '5px' });
  }

  async loadArticlesFromIndexedDB(): Promise<boolean> {
    return this.localStorageService.get("produkte", this.dbStorageSA).then
      (
        value => {
          if (value === false) {
            // Es konnte keinen Wert in der indexeddb für Produkte ermittelt werden
            return false;
          }
          else {
            // Die Produkte konnten geladen werden
            if (value) {
              this.dbProdukte = <ServiceAppModels.Produkt[]>value;
              this.dataSource! = new MatTableDataSource<ServiceAppModels.Produkt>(this.dbProdukte);
              this.dataSource!.paginator = this.paginator!;
              this.isLoadingResults = false;
            }
            return true;
          }
        }
      );
  }

  highlight(row: any) {
    if (this.productIsChoosed) {
      // demarkieren
      this.selectedProductNo = "";
      this.productIsChoosed = false;
    }
    else {
      this.selectedProductNo = row.productNo;
      this.productIsChoosed = true;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  save() {
    // ausgewähltes Produkt als Artikel erfassen ==> Erfassungsmaske anzeigen
    this.dialogRef.close(this.selectedProductNo);
  }

}
